import { useCallback, useMemo } from "react";

import Clipboard from "./Clipboard.jsx";

const LeftMenu = ({
    listData,
    listAttr = "name",
    listOnClick,
    selectedTab = "",
    showClipboard = true,
    disabled,
    buttons
}) => {
    const handleClick = useCallback((event, dataElement, value) => {
        if (!disabled) {
            event.preventDefault();
            listOnClick(dataElement, value);
        }
    }, [listOnClick, disabled]);

    const listItems = useMemo(() => listData.map((element, index) => {
        return (
            <button
                key={index}
                className={`list-group-item small list-group-item-action text-center text-lg-start ${selectedTab === element._id ? "active" : ""}`}
                data-element={element._id}
                onClick={(event) => handleClick(event, element._id, element[listAttr])}
            >{element[listAttr]}</button>
        )
    }), [listData, listAttr, selectedTab, handleClick]);

    return (
        <div className="col-12 col-lg-2 border-lg-end d-flex flex-column">
            {listData && <div className={`list-group pt-3 pe-lg-3`}>
                {listItems}
            </div>}
            {buttons && <div className="row border-top border-accenture mt-3">
                {buttons}
            </div>}
            {showClipboard && <div className="pe-lg-3 pt-3">
                <Clipboard />
            </div>}
        </div>
    );
}

export default LeftMenu;